import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {Accordion, AccordionSummary, AccordionDetails, Typography, List} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const GroupRenderer = ({ category, group, layerRenderer, keyVal, renderHidden }) => {

  const [, updateGroupState] = useState(category?.expanded !== undefined ? category.expanded : false);

  const layers = group.layers.filter(lyr => !lyr?.config?.hidden || renderHidden).map(lyr => {
    let layerRenderParam = {
      keyVal: lyr.key,
      layer: lyr,
      category: category,
      updateGroup: () => {
        updateGroupState(Math.random());
      }
    };
    return layerRenderer(layerRenderParam);
  });

  return (
    <div className="group" key={keyVal}>
      <div className="group-name">{group.name}</div>
      <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
        {layers}
      </List>
    </div>
  )
}

GroupRenderer.propTypes = {
  category: PropTypes.object,
  group: PropTypes.object,
  layerRenderer: PropTypes.func,
  keyVal: PropTypes.any,
  renderHidden: PropTypes.bool,
}

const CategoryRenderer = ({ category, layerRenderer, renderHidden, onlyChild }) => {
  const [, setCategoryExpanded] = useState(category?.expanded !== undefined ? category.expanded : false);
  const handleExpand = (event, expanded) => {
    category.expanded = expanded;
    setCategoryExpanded(expanded);
  };

  if (category.groups && category.groups.length > 0) {
    const groups = category.groups.map((grp) => {
      return <GroupRenderer key={grp?.key} group={grp} category={category} layerRenderer={layerRenderer} renderHidden={renderHidden} />
    });

    if (onlyChild) {
      return <>
        {groups}
      </>
    }

    return (
      <div className="category">
        <Accordion expanded={category.expanded !== undefined ? category.expanded === true : false} onChange={handleExpand}>

          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${category?.key}-content`}
            id={`panel${category?.key}-header`}
            className="category-name"
            sx={{
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              '& .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root': { color: 'primary.contrastText' } // use summary hover icon color
            }}
          >
            <Typography>{category?.name || 'Missing Category'}</Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ padding: 0 }}>
            {groups}
          </AccordionDetails>

        </Accordion>
      </div>
    );
  } else {
    return (<p>No Groups!</p>);
  }
}

CategoryRenderer.propTypes = {
  category: PropTypes.object,
  layerRenderer: PropTypes.func,
  renderHidden: PropTypes.bool,
  onlyChild: PropTypes.bool,
}


const CategoriesRenderer = ({ categories, layerRenderer, renderHidden }) => {
  const renderableCategories = categories.filter(cat => !cat?.config?.hidden || renderHidden);
  const rendered = renderableCategories.map((category) => {
    return <CategoryRenderer key={category?.key} category={category} layerRenderer={layerRenderer} renderHidden={renderHidden} onlyChild={renderableCategories.length === 1} />
  });

  return (
    <div className="categoriesContainer">
      {rendered}
    </div>
  )

}

CategoriesRenderer.propTypes = {
  categories: PropTypes.array,
  layerRenderer: PropTypes.func,
  renderHidden: PropTypes.bool,
}


const CategoryGroupLayerRenderer = ({ categories, LayerRenderer, renderHidden }) => {
  if (categories) {
    return (<CategoriesRenderer categories={categories} layerRenderer={LayerRenderer} renderHidden={renderHidden} />);
  }

  return (<div>Loading...</div>);
}

CategoryGroupLayerRenderer.propTypes = {
  categories: PropTypes.array,
  LayerRenderer: PropTypes.func,
  renderHidden: PropTypes.bool,
}


export default CategoryGroupLayerRenderer;